export default {"src":"/_next/static/media/message-us-regular.2cf6720f.svg","height":111,"width":149};